import type { ApiRequest, RequestRoutes } from '@/request/requestRouter'
import { RequestAction } from '@/request/requestRouter'
import disconnectUserMiddleware from '@/request/middlewares/disconnectUser'
import checkNotificationMiddleware from '@/request/middlewares/notification'
import FapFapError from '@/errors/FapFapError'

const upscale: ApiRequest = {
	action: RequestAction.Upscale,
	endpoint: '{{uuid}}/upscale?fastlane={{fastlane=false}}',
	config: {
		method: 'POST',
		credentials: 'include',
	},
}

const generate: ApiRequest = {
	action: RequestAction.Generate,
	endpoint: 'txt2img?fastlane={{fastlane=false}}',
	config: {
		method: 'POST',
		credentials: 'include',
	},
}

const generatePrompt: ApiRequest<string> = {
	action: RequestAction.GeneratePrompt,
	endpoint: 'tags',
	config: {
		method: 'POST',
		credentials: 'include',
	},
	afterRequest: async (response: Response) => {
		if (!response.ok) {
			throw FapFapError.rateLimited()
		}

		return (await response.json())?.output ?? ''
	},
}

const generatePromptNL: ApiRequest<string> = {
	action: RequestAction.GenerateNLPrompt,
	endpoint: 'nl_convert',
	config: {
		method: 'POST',
		credentials: 'include',
	},
	afterRequest: async (response: Response) => {
		if (!response.ok) {
			throw FapFapError.rateLimited()
		}

		return (await response.json())?.output ?? ''
	},
}

const styleToStyle: ApiRequest = {
	action: RequestAction.StyleToStyle,
	endpoint: 'img2img/convert?fastlane={{fastlane=false}}',
	config: {
		method: 'POST',
		credentials: 'include',
	},
}

const inPaint: ApiRequest = {
	action: RequestAction.InPaint,
	endpoint: 'img2img/inpaint?fastlane={{fastlane=false}}',
	config: {
		method: 'POST',
		credentials: 'include',
	},
}

export default {
	prefix: '/api/tasks',
	middlewares: [disconnectUserMiddleware, checkNotificationMiddleware],
	queries: [upscale, generate, generatePrompt, styleToStyle, inPaint, generatePromptNL],
} as RequestRoutes
